// @flow
import React, { Component } from 'react';

import { STATUS_LOADING, STATUS_SUCCESS } from 'constants/statusConstants';
import type { PageChildType } from 'types/PageNode';
import MenuElement from 'components/header/MenuElement';
import MenuElementPlus from 'components/header/MenuElementPlus';
import { dynamicClassName } from 'utils/dynamicClassName';
import { withRouter } from 'react-router-dom';

export type StateProps = {
  subMenus: Array<PageChildType>,
  status: string
};

type Props = {
  subMenuPath: string,
  niveauMenu: number,
  location: Location,
  navClass?: string
} & StateProps;

type ComponentState = {
  isMobile: boolean,
  hiddenMenuItems: Array<number>,
  menuLinkX: number,
  isOpen: boolean,
  menuIsActive: number
};

const SUBROUTER_LINK_SIZE = 240;

class SubMenuHeader extends Component<Props, ComponentState> {
  _menuElements: Array<?MenuElement>;
  _menu: ?HTMLElement;
  _menuLink: ?HTMLElement;
  state: ComponentState = {
    isMobile: false,
    hiddenMenuItems: [],
    menuLinkX: 0,
    isOpen: false,
    menuIsActive: 0
  };

  static defaultProps = {
    niveauMenu: 3
  };

  constructor(props: Props) {
    super(props);
    this._menuElements = [];
  }

  componentDidMount() {
    this.updateDimensions();
    window.addEventListener('resize', this.updateDimensions.bind(this));
    const { location, subMenus, niveauMenu } = this.props;
    const parseUrl = location.pathname.split('/');
    if (parseUrl.length > 2) {
      subMenus.forEach((subMenu, index) => {
        if (subMenu.object_slug === parseUrl[niveauMenu]) {
          this.activateMenu(index);
        }
      });
    }
  }

  componentDidUpdate(prevProps: Props) {
    if (this.props.status === STATUS_LOADING) {
      this._menuElements = [];
      if (this.state.menuIsActive !== 0) {
        this.setState({ menuIsActive: 0 });
      }
    }

    if (
      (this.props.status === STATUS_SUCCESS && prevProps.status === STATUS_LOADING) ||
      this.props.location !== prevProps.location
    ) {
      const { location, subMenus, niveauMenu } = this.props;
      const parseUrl = location.pathname.split('/');
      if (parseUrl.length > 2) {
        this.activateMenu(0);
        subMenus.forEach((subMenu, index) => {
          if (subMenu.object_slug === parseUrl[niveauMenu]) {
            this.activateMenu(index);
          }
        });
      }
    }
    this.updateDimensions();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions.bind(this));
  }

  resetMenuElementRef = (c: ?MenuElement) => {
    this._menuElements = [];
    this.addMenuElementRef(c);
  };

  addMenuElementRef = (c: ?MenuElement) => {
    this._menuElements.push(c);
  };

  isDisplayed = (id: number) => {
    return !this.state.hiddenMenuItems.includes(id);
  };

  onHandleSubMenuMobile = () => {
    const { isOpen } = this.state;
    this.setState({
      isOpen: !isOpen
    });
  };

  updateDimensions() {
    const menu = this._menu;
    // const menuLink = this._menuLink;

    if (menu) {
      const menuLinkBounds: any = menu.getBoundingClientRect();
      const menuLinkX = menuLinkBounds.left;

      if (menuLinkX !== this.state.menuLinkX) this.setState({ menuLinkX });
      let maxWidth = menu.getBoundingClientRect().width; // on n'a plus de marge sur les côtés => la largeur complète du menu

      // if (maxWidth > 1157) { // on n'a plus de marge sur les côtés => la largeur complète du menu
      //   maxWidth -= 120;
      // }
      if (maxWidth > 1540) {
        // quid de au-delà de 1540px ?
        maxWidth = 1540;
      }

      const width_menu_links =
        // this._menuElements.reduce((total, item) => (item ? total + item.getSize() : total), 0) +
        this._menuElements.length * SUBROUTER_LINK_SIZE;

      let currentWidth = width_menu_links;
      let deleted = [];
      if (maxWidth > 644) {
        for (let i = this._menuElements.length - 1; i > 0; i--) {
          if (currentWidth > maxWidth) {
            if (this._menuElements[i]) currentWidth -= SUBROUTER_LINK_SIZE - 16;
            deleted = [...deleted, i];
          }
        }
        if (this.state.isMobile) this.setState({ isMobile: false });
      } else {
        if (!this.state.isMobile) this.setState({ isMobile: true });
      }

      if (
        (deleted.length !== this.state.hiddenMenuItems.length &&
          (deleted.length > 0 || this.state.hiddenMenuItems.length > 0) &&
          !deleted.every(id => this.state.hiddenMenuItems.includes(id))) ||
        !this.state.hiddenMenuItems.every(id => deleted.includes(id))
      ) {
        this.setState({ hiddenMenuItems: deleted });
      }
    }
  }

  activateMenu = (id: number) => {
    this.setState({
      menuIsActive: id,
      isOpen: false
    });
  };

  renderMenu = () => {
    const { subMenus, subMenuPath } = this.props;
    const { menuIsActive } = this.state;

    const test = subMenus.map((menu, index) => {
      let url = menu.object_slug;
      if (menu.type_name !== 'external') {
        if (menu.object_slug === '' || menu.object_slug[0] !== '/') {
          url = `${subMenuPath}${menu.object_slug === '' ? '' : '/' + menu.object_slug}`;
        }
      }
      return (
        <MenuElement
          url={url}
          urlType={menu.type_name}
          title={menu.title}
          titleAll="Toutes les informations"
          isMobile={false}
          ref={ref => (index === 0 ? this.resetMenuElementRef(ref) : this.addMenuElementRef(ref))}
          id={index}
          isDisplayed={this.isDisplayed}
          menuX={this.state.menuLinkX}
          activateMenu={this.activateMenu}
          isActive={index === menuIsActive}
          key={index}
        />
      );
    });
    return test;
  };

  render() {
    const { subMenus, status, navClass } = this.props;
    const { isOpen, isMobile, menuIsActive } = this.state;

    const navClassName = dynamicClassName('navbar');
    navClass && navClassName.add(navClass);

    const titleClassName = dynamicClassName('accordion-trigger ft-up ');
    isOpen && subMenus.length > 1 && titleClassName.add('is-selected') && navClassName.add('has-accordion-open');

    const menuContainerClassName = dynamicClassName('container subrouter-links accordion-panel navbar__links');
    (subMenus.length === 1 || (!isOpen && isMobile)) && menuContainerClassName.add('is-hidden');

    const hiddenMenuElements = this.state.hiddenMenuItems
      .map(id => {
        return this._menuElements[id];
      })
      .sort((a, b) => {
        /**
         * @XXX Flow doesn't support props getter from HTML Element
         * Oh wait ... https://github.com/facebook/flow/issues/740#issuecomment-418582749
         * Sorry :'(
         */
        // $FlowFixMe
        if (a.props.titleAll > b.props.titleAll) {
          return 1;
        }
        // $FlowFixMe
        if (a.props.titleAll < b.props.titleAll) {
          return -1;
        }
        return 0;
      })
      .reverse();
    const nbVisibleMenuElements = subMenus.length - hiddenMenuElements.length;
    const menuElementPlusId = nbVisibleMenuElements;

    return (
      <nav className={navClassName.build()}>
        <a className={titleClassName.build()} role="button" tabIndex={0} onClick={this.onHandleSubMenuMobile}>
          {status === STATUS_LOADING ? subMenus[0].title : subMenus[menuIsActive].title}
        </a>
        <ul className={menuContainerClassName.build()} ref={c => (this._menu = c)}>
          {this.renderMenu()}
          <MenuElementPlus
            hiddenMenuElements={hiddenMenuElements}
            isMobile={this.state.isMobile}
            id={menuElementPlusId}
            isDisplayed={this.isDisplayed}
            menuX={this.state.menuLinkX}
            activateMenu={this.activateMenu}
            isActive={menuElementPlusId === menuIsActive}
            text="En voir plus"
            isNavbar={true}
          />
        </ul>
      </nav>
    );
  }
}

export default withRouter(SubMenuHeader);
